"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeProp = void 0;
const monet_1 = require("monet");
const { None, fromNull } = monet_1.Maybe;
function safeProp(key, x) {
    return arguments.length === 2
        ? x !== undefined && key !== undefined ? fromNull(x[key]) : None()
        : (y) => y !== undefined && key !== undefined ? fromNull(y[key]) : None();
}
exports.safeProp = safeProp;
//# sourceMappingURL=safeProp.js.map